module.exports = __webpack_public_path__ + "static/scale-model-of-mission-san-luis-in-tallahassee-florida-a579e1b3dacd11eedec3bf72b93b4163.png";